import getApplePayInstance from '@/utils/ApplePay/getApplePayInstance'
import actions from './actions'

export default {
  namespaced: true,
  state() {
    return {
      applePay: (cart, installment) => getApplePayInstance(cart, installment).applePay(),
    }
  },
  actions,
}
